import { render, staticRenderFns } from "./FormBtnEdit.vue?vue&type=template&id=22dfaf02"
import script from "./FormBtnEdit.vue?vue&type=script&lang=js"
export * from "./FormBtnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22dfaf02')) {
      api.createRecord('22dfaf02', component.options)
    } else {
      api.reload('22dfaf02', component.options)
    }
    module.hot.accept("./FormBtnEdit.vue?vue&type=template&id=22dfaf02", function () {
      api.rerender('22dfaf02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormBtnEdit.vue"
export default component.exports